import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "file",
  "use": "file-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"file\"><path d=\"M3 2a1 1 0 011-1h5.143a1 1 0 01.633.226L14.633 5.2a1 1 0 01.367.774V16a1 1 0 01-1 1H4a1 1 0 01-1-1V2z\" /><path d=\"M9 1h.322a.5.5 0 01.316.113l5.179 4.237a.5.5 0 01.183.387V6h-5a1 1 0 01-1-1V1z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol